import React, { useEffect, useState } from 'react'
import { t } from '../Language/Translator'
import useUserStore from '../../store/UserStore';
import notificationsound from "../../../src/images/basic_beep.mp3";
import { toast } from "react-toastify";
import axios from 'axios';
import { BASE_URL, REACT_APP_ANDROID_INSTALLATION_LINK, REACT_APP_IOS_INSTALLATION_LINK } from '../../constant/const';
import useChatStore from '../../store/ChatStore';
import { useMutation } from '@tanstack/react-query';
import { updateChatCount } from '../../services/ticket_api';
//import { FaApple, FaGooglePlay } from 'react-icons/fa';
import android from "../../assets/images/android-svg.svg";
import ios from "../../assets/images/ios-svg.svg";
const Footer = () => {
  const user_data = useUserStore((state) => state.user);
  const token = user_data;
  const userInfo = useUserStore((state) => state.userInfo);
  const user_email = userInfo?.email;
  const [lastId, setLastId] = useState(null);
  const chatInfo = useChatStore((state) => state.chat);
  let last_Ticket_Id;
  const playSound = () => {
     const audio = new Audio(notificationsound);
       notify(`A new message has been received from ticket id ${last_Ticket_Id}.`);
      audio.play().catch((error) => {
        console.error('Error playing sound:', error);
      });
      mutateChatCount(last_Ticket_Id);
  };
const { mutate: mutateChatCount, isPending } = useMutation({
        mutationFn: (ID) => updateChatCount(token, ID),
        onSuccess: function (data) {
        },
        onError: function (error) {
            toast.error(error.message);
        },
    });
  const notify = (message) => {
    toast.info(message, {
        autoClose: false, 
        closeOnClick: false, 
        draggable: true, 
    });
};

  const fetchChats = async () => {
    const config = {
      headers: {
        "Content-type": "application/json",
        "Authorization": token,
      },
    };
    const response = await axios.get(`${BASE_URL}chat/chats`, config);
    if (response.data.status === "success") {
      const newMessages = response.data.data;
     
      if (newMessages.length > 0) {
        const currentLastId = newMessages[newMessages.length - 1].id;
        last_Ticket_Id =newMessages[newMessages.length - 1].ticket_id;
       // if (lastId !== currentLastId) {
          newMessages.forEach(message => {
            const filesArray = message.files.split(',');
            if (!filesArray.includes(message?.email) && filesArray.includes(user_email) && (chatInfo === true || chatInfo == null)) {
              setLastId(currentLastId); 
              playSound(); 
            }
            // console.log('222222222222',userInfo.user_type);
            // console.log('333333333333',chatInfo);
            if((['super_admin', 'admin', 'analyst'].includes(userInfo?.user_type))&& userInfo?.email !== newMessages[0]?.email){
              // console.log("Super admin", userInfo.email);
               //  console.log("Fetched messages:", newMessages[0].email);
              setLastId(currentLastId); 
              playSound();
            }
          });
      }
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      fetchChats();
    }, 5000);
    return () => clearInterval(interval);
  }, [lastId, chatInfo,token]);

  return (
    <>
      <div style={{ textAlign: 'center' }}>{t("footer.copyright")}</div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <a 
          href={REACT_APP_ANDROID_INSTALLATION_LINK}
          target="_blank" 
          rel="noreferrer"
          style={{ display: 'flex', alignItems: 'center', flexWrap:'wrap' }}
        >
          <img src={android} style={{ width: '190px', height: '70px' }} />
        </a>
        <a 
          href={REACT_APP_IOS_INSTALLATION_LINK}
          target="_blank" 
          rel="noreferrer"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <img src={ios} style={{ width: '190px', height: '50px' }} />
        </a>
      </div>
    </>
  )
}

export default Footer;